<template>
    <div id="dash-root">
        <admin-create-dash-component v-for="(dashpart, index) in dashparts" class="panel panel-flat"
                                        :part="dashpart"
                                        :key="index">
        </admin-create-dash-component>
    </div>

</template>

<script>

    export default {
        props: ['admin_id', 'admin_name', 'route_refresh'],
        name: "admin-dash",
        data () {
            return {
                dashparts: []
            };
        },
        mounted () {
            let self = this;
            axios.get(this.route_refresh)
                .then(function (response) {
                    self.dashparts = response.data;
                })
                .catch(function (error) {
                })
        }
    }
</script>

<style scoped>

</style>
